module.exports = __webpack_public_path__ + "static/media/Code.c0ce0b5a.jpeg";